import { NgModule } from '@angular/core';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { PollComponent } from './poll.component';
import { PreguntaComponent } from './pregunta.component';
import { DragulaModule } from 'ng2-dragula';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ResultadosComponent } from './resultados.component';
import { ChartModule } from 'angular2-highcharts';
import { DatePickerModule } from '../../_extra/datepicker.module';
import { Ng2PaginationModule } from 'ng2-pagination';
import { FileHandlerService } from '../../_services/file.service';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FileUploadModule, DragulaModule, ChartModule.forRoot(require('highcharts')), DatePickerModule, Ng2PaginationModule,],
    declarations: [PollComponent, PreguntaComponent, ResultadosComponent],
    exports: [PollComponent, PreguntaComponent, ResultadosComponent],
    providers: [FileHandlerService],
})
export class PollsModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/polls/polls.module.ts